import InputLabel from '@mui/material/InputLabel';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Chip from '@mui/material/Chip';
// import Checkbox from '@mui/material/Checkbox';
import CONSTANTS from '../constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function SelectTax(props) {
    const extraProps = {};
    if (props.tax.slug === 'localizacao') {
        extraProps.groupBy = (opcao) => {
            return (CONSTANTS.RECORTES_TERRITORIAIS.hasOwnProperty(opcao.tax))
                ? CONSTANTS.RECORTES_TERRITORIAIS[opcao.tax].nome
                : CONSTANTS.SUB_RECORTES_TERRITORIAIS[opcao.tax].nome;
        };
    }
    if (props.tax.slug === 'sujeito') {
        extraProps.groupBy = (opcao) => {
            return CONSTANTS.RECORTES_IDENTIDADE[opcao.tax].plural;
        };
    }

    const updateTaxFilters = (selection) => {
        const newFilters = {[props.tax.slug]: selection};
        if (props.tax.slug === 'localizacao' && selection.tax !== 'uf' && props.recorteTerritorial === 'municipio') {
             newFilters.recorteTerritorial = '-1';
        }
        props.changeFilter(newFilters);
    };

    const deleteTaxFilter = (e, value) => {
        // e.preventDefault();
        if (props.filtersTax.length === 1) {
            updateTaxFilters([]);
            return;
        }

        let selection = [];
        for (let filterTax of props.filtersTax) {
            if (filterTax.slug !== value.slug) {
                selection.push(filterTax);
            }
        }
        updateTaxFilters(selection);
    };

    // console.log(props.opcoesTax);

    return (
        <>
        {props.isMobile && 1 === 2
            ?
            <>
            <InputLabel>{props.tax.placeholder}</InputLabel>
            <Select
                key={`autocomplete_${props.tax.slug}`}
                id={`autocomplete_${props.tax.slug}`}
                value={props.filtersTax}
                multiple
                label={props.tax.placeholder}
                renderValue={(selected) => (
                    <>
                    {selected.map((value) => (
                        <Chip
                            key={`${props.tax.slug}_${value.slug}`}
                            label={value.label}
                            clickable
                            deleteIcon={
                                <FontAwesomeIcon
                                    icon={"times-circle"}
                                    onMouseDown={(event) => event.stopPropagation()}
                                />
                            }
                            onDelete={(e) => deleteTaxFilter(e, value)}
                            onClick={() => console.log("clicked chip")}
                        />
                    ))}
                    </>
                )}
                onChange={(e) => {
                    const selection = e.target.value;
                    updateTaxFilters(selection);
                }}
            >
            {props.opcoesTax.map((opcao) => (
                <MenuItem key={opcao.slug} value={opcao}>
                    {opcao.label}
                </MenuItem>
            ))}
            </Select>
            </>

            : <Autocomplete
                key={`autocomplete_${props.tax.slug}`}
                id={`autocomplete_${props.tax.slug}`}
                disablePortal
                options={props.opcoesTax}
                fullWidth={true}
                value={props.filtersTax}
                multiple={true}
                autoHighlight
                renderInput={(params) => <TextField {...params} label={props.tax.placeholder} />}
                renderOption={(props, option) => {
                    return (
                        <li
                            {...props}
                            key={option.hasOwnProperty('tax') ? `${option.tax}_${option.slug}` : option.slug}
                        >
                            {option.label}
                        </li>
                    );
                }}
                isOptionEqualToValue={(option, value) => option.slug === value.slug}
                onChange={(e, selection) => {
                    updateTaxFilters(selection);
                }}
                {...extraProps}
            />
        }
        </>
    );
}
